import ct from 'countries-and-timezones';

// A custom hook that returns your country
function useTimeZone() {
  let timeZone;
  let country;
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    country = ct.getCountryForTimezone(timeZone).id;
  } catch (e) {
    timeZone = 'America/Los_Angeles';
    country = 'US';
  }
  return {
    timeZone,
    country
  };
}
export default useTimeZone;